import React from 'react';
import { ConfigProvider } from 'antd';

interface EmptyConfigProps {
  desc?: React.ReactNode;

  style?: React.CSSProperties;
}

const EmptyConfig = ({ desc, style, children }: React.PropsWithChildren<EmptyConfigProps>): React.ReactElement => {
  const item = () => <div style={style || { textAlign: 'center', color: 'black' }}>{desc}</div>;

  return <ConfigProvider renderEmpty={item}>{children}</ConfigProvider>;
};

export default EmptyConfig;
